export const setUserMetadata = (payload: any) => {
  return { type: "SET_USER_STATE", payload };
};
export const setDashboardData = (payload: any) => {
  return { type: "SET_DASHBOARD_DATA", payload };
};
export const setTimeSeriesStoreData = (payload: any) => {
  return { type: "SET_TIMESERIES_DATA", payload };
};
